import { ClientTypeBrand } from 'src/types/brand';
import {Alert} from 'src/types/nms';
import { ClientTypeLocation } from 'src/types/location';
import { DisplayUser, User, UserCollection } from 'src/types/user';

export const generateRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

// Transform the collection into an array of users
export const transformUserCollection = (
  userCollection: UserCollection,
): DisplayUser[] => {
  return Object.keys(userCollection).map((key) => {
    const user = userCollection[key];
    return {
      id: key, // Unique identifier for the user
      displayName: user?.displayName || 'Unknown', // User name
      company: user?.company || 'Unknown', // Company name
      email: user?.email || 'Unknown', // Email address
      userType: user?.userType || 'Unknown', // User role
      brands: user?.dash.brands || undefined,
      locations: user?.dash.locations || undefined,
      servicerApp: user?.dash.servicerApp || undefined,
      superAdmin: user?.dash.superAdmin || false,
    };
  });
};

export const transformBrandsCollection = (
  userCollection:
    | Record<string, ClientTypeBrand>
    | Record<string, ClientTypeLocation>,
): ClientTypeBrand[] | ClientTypeLocation[] => {
  return Object.keys(userCollection).map((key) => {
    const data = userCollection[key];
    return {
      ...data,
      id: key,
      brandKey: key, // Unique identifier for the user
    };
  });
};

export const transformAlertIdCollection = (
  userCollection:
    | Record<string, Alert>
): Alert[] => {
  return Object.keys(userCollection).map((key) => {
    const data = userCollection[key];
    return {
      ...data,
      id: key,
      //alertKey: key, // Unique identifier for the user
      alertKey: String(data.alert_id),
    };
  });
};

export function capitalizeFirstLetter(input: string): string {
  if (input.length === 0) return input; // Return if the string is empty
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export default function arrayToObjectWithTrueValues(
  arr: string[],
): Record<string, boolean> {
  return arr.reduce(
    (acc, key) => {
      acc[key] = true;
      return acc;
    },
    {} as Record<string, boolean>,
  );
}

export const createOrganizationsWithRoles = (
  brands: Record<string, any>,
  currentUser: any,
  roles: Record<string, any>,
  activeTab: number,
) => {
  console.log(currentUser);
  console.log(brands);
  console.log(roles);
  if (brands == null || currentUser == null || roles == null) return [];
  let userBrands = null;
  let brandCommonRoles: any[] = []; // Extract user's roles
  let selectedBrands = [];

  if (activeTab == 0) {
    userBrands = currentUser.brands ? currentUser.brands : null;
    selectedBrands =
      currentUser.organizations === 'All Organizations'
        ? Object.keys(brands)
        : currentUser.organizations;
    brandCommonRoles = userBrands.brandCommonRoles
      ? Object.keys(userBrands.brandCommonRoles)
      : [];
  } else if (activeTab == 2) {
    selectedBrands =
      currentUser.organizations === 'All Locations'
        ? Object.keys(brands)
        : currentUser.organizations;
    userBrands = currentUser.locations ? currentUser.locations : null;
    brandCommonRoles = userBrands.locationCommonRoles
      ? Object.keys(userBrands.locationCommonRoles)
      : [];
  } else {
    selectedBrands =
      currentUser.organizations === 'All Organizations'
        ? Object.keys(brands)
        : currentUser.organizations;
    userBrands = currentUser.servicerApp ? currentUser.servicerApp : null;
    brandCommonRoles = userBrands.brandCommonRoles
      ? Object.keys(userBrands.brandCommonRoles)
      : [];
  }
  console.log('userBrands', userBrands);
  console.log('brands', brands);
  if (userBrands == null) return [];
  const userType = currentUser.userType; // 'internal' or 'external'

  const availableRoles = Object.keys(roles);

  let selectedExceptions = currentUser.exceptions ?? [];
  let selectedOrganizations: any = [];
  let availableOrganizations: any = [];

  let sRoles = [];
  let publicRoles = [];

  // Iterate over each brand and assign roles
  const organizations = Object.keys(brands).map((brandKey) => {
    const brandData = brands[brandKey];

    if (brandCommonRoles.length == 0) {
      if (activeTab == 2) {
        brandCommonRoles = userBrands.locationList[brandKey]
          ? (Object.keys(userBrands.locationList[brandKey]) ?? [])
          : [];
      } else {
        brandCommonRoles = userBrands.brandList[brandKey]
          ? Object.keys(userBrands.brandList[brandKey])
          : [];
      }
    }
    // Filter roles based on userType and role type
    sRoles = brandCommonRoles.map((roleId) => ({
      id: roleId,
      ...roles[roleId], // Get role details from the roles object
    }));
    publicRoles = availableRoles
      .map((roleId) => ({
        id: roleId,
        ...roles[roleId], // Get role details from the roles object
      }))
      .filter((role) => role.type === userType); // Match the role type to user type
    let userItem = {
      id: brandKey,
      name: brandData.name,
      address: brandData.address,
      timezone: brandData.timezone || null,
      currency: brandData.currency || null,
      roles: sRoles.map((role) => ({
        id: role.id,
        name: role.name,
      })), // Map to include role id and name
      publicRoles: publicRoles.map((role) => ({
        id: role.id,
        name: role.name,
      })),
    };

    if (
      selectedBrands &&
      selectedBrands.includes(brandKey) &&
      !selectedExceptions.includes(brandKey)
    ) {
      selectedOrganizations.push(userItem);
    } else {
      availableOrganizations.push(userItem);
    }
    // if(selectedExceptions  && selectedExceptions.includes(brandKey)){
    //   availableOrganizations.push(userItem)
    // }

    return userItem;
  });
  return {
    aorgs: availableOrganizations,
    sorgs: selectedOrganizations,
    publicRoles,
  };
};

export const cleanParams = (
  params: Record<string, any>,
): Record<string, any> => {
  // Filter out keys where the value is null, undefined, or an empty string
  return Object.keys(params).reduce(
    (acc, key) => {
      if (
        key != null &&
        key.length != 0 &&
        params[key] !== null &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        acc[key] = params[key];
      }
      return acc;
    },
    {} as Record<string, any>,
  );
};
/**
 * Formats a number or a string representing a number with commas as thousand separators.
 * @param input - The number or string to format.
 * @returns A string with the formatted number or an empty string if invalid input.
 */
export const formatWithCommas = (input: number | string): string => {
  if (input == undefined || input == null) return '';
  const num = typeof input === 'string' ? parseFloat(input) : input;
  if (isNaN(num)) return ''; // Return empty string if input is invalid
  return num.toLocaleString('en-US');
};

export const formatPercentage = (
  value: number | string,
  total: number | string,
): string => {
  if (
    value == null ||
    total == null ||
    isNaN(Number(value)) ||
    isNaN(Number(total))
  ) {
    return '';
  }
  const num = parseFloat(value as string);
  const numTotal = parseFloat(total as string);
  if (numTotal === 0) return '0.00'; // Avoid division by zero
  return ((num / numTotal) * 100).toFixed(2);
};

/**
 * Formats a number or a string representing a number as a dollar price with commas and two decimal places.
 * @param input - The number or string to format.
 * @returns A string with the formatted dollar price or an empty string if invalid input.
 */
export const formatAsPrice = (input: number | string): string => {
  if (input == undefined || input == null) return '';
  const num = typeof input === 'string' ? parseFloat(input) : input;
  if (isNaN(num)) return ''; // Return empty string if input is invalid
  return `$${num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

/**
 * Converts a large number or string representing a large number into a shortened format (e.g., 1000 to 1k).
 * @param input - The number or string to format.
 * @returns A string with the shortened format or an empty string if invalid input.
 */
export const formatToShortNumber = (input: number | string): string => {
  if (input == undefined || input == null) return '';
  const num = typeof input === 'string' ? parseFloat(input) : input;
  if (isNaN(num)) return ''; // Return empty string if input is invalid

  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(1)}M`; // Convert to millions
  } else if (num >= 1_000) {
    return `${(num / 1_000).toFixed(1)}k`; // Convert to thousands
  }
  return `${num}`; // Return as is for numbers below 1,000
};


export const getAggregationForTicks = (input: string): string => {
  const data: Record<string, string> = {
    hourly: "1h",
    daily: "1d",
    weekly: "1w",
    monthly: "1M",
    minutely: "1m",
  };

  return data[input.toLowerCase()] || "1d"; // Ensure the input is case-insensitive
};